import { render, staticRenderFns } from "./GraficosComponent.vue?vue&type=template&id=2adca1fc"
import script from "./GraficosComponent.vue?vue&type=script&lang=js"
export * from "./GraficosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adca1fc')) {
      api.createRecord('2adca1fc', component.options)
    } else {
      api.reload('2adca1fc', component.options)
    }
    module.hot.accept("./GraficosComponent.vue?vue&type=template&id=2adca1fc", function () {
      api.rerender('2adca1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Dashboard/GraficosComponent.vue"
export default component.exports